var Backbone = require("../../libs/backbone/backbone");
var GenericModel = require("./generic.model.ts");

var Model = GenericModel.extend(
{
    urlRoot : '/rest/api/admin/tickets',
    id : null,
    customerCode : "",
    number : -1,
    isPriorityTicket : false,
    status : "",
    createdTime : null,
    queueName : "",
    venueName : "",
    organizationName : "",
    queueId : null,
    venueId : null,
    organizationId : null,
    counterName: "",
    customerCodeLastDigits: ""
});

module.exports = Model;